import React from 'react';
import BaseTable from './BaseTable';

const EditorPreview = () => {
  const tableHeaders = [
    "",
    "Entered Queue",
    "Channel",
    "Author",
    "Title",
    "History"
  ]

  const rowNames = [
    "checkbox",
    "most_recent_activity",
    "channel_name",
    "admin_user_link",
    "title",
    "reminder_history"
  ]

  const columnAmountAndWidths = [
    {width: '50px', class: 'centered'},
    {width: '180px'},
    null,
    {width: '160px'},
    null,
    {width: '100px', class: 'centered'}
  ]

  return <BaseTable
          tableHeaders={tableHeaders}
          state={"editor_preview"}
          rowNames={rowNames}
          historyElementColumnIndex={5}
          removeOrderingColumn={[0,5]}
          columnAmountAndWidths={columnAmountAndWidths}
          enableEmailReminder={true}
          emailTemplateName={"EditorPreview"}
          canSelectOnlyOneCheckbox={true}
          />
}

export default EditorPreview;